export default __webpack_public_path__ + "static/media/htb-darcy.acc62cc1.jpg";